var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-form.285afbc8.png","uri@2x": __webpack_public_path__ + "icon-form.c238c7a5.png","uri@3x": __webpack_public_path__ + "icon-form.8ce102cc.png",
    width: 17,
    height: 22
});